<template>
  <div
    v-if="text"
    class="info-status d-flex flex-row align-items-center"
    :class="status"
  >
    <i-icon
      :symbol="
        status === 'success' ? 'small-check-circle' : 'small-alert-circle'
      "
      :class="status === 'success' ? 'i-text-success-100' : 'i-text-error-100'"
      :size="16"
    ></i-icon>
    <span>{{ text }}</span>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';

export default {
  components: {
    'i-icon': iIcon,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: 'success',
    },
  },
};
</script>

<style lang="scss" scoped>
.info-status {
  padding: 10px 12px;
  background: $light-success-30;
  color: $light-success-110;
  border-radius: 12px;
  gap: 12px;
  font-weight: 500;
  margin-bottom: 24px;

  &.error {
    background: #ffefef;
    color: $light-error-110;
  }
}
</style>
